/** SQAAF section/chapter/management display labels (mirrors backend/data/sqaaf_section_labels.json). */

const CHAPTERS = {
  1: "School Leadership and Management",
  2: "Teaching-Learning and Assessment",
  3: "Learner Progress, Attainment and Development",
  4: "Infrastructure, Safety and Hygiene",
  5: "Inclusive Practices and Community Participation",
  6: "Governance, Innovation and Continuous Improvement",
};

const SECTIONS = {
  "1.1": "Vision and mission",
  "1.2": "School development plan",
  "1.3": "Leadership practices",
  "1.4": "Governance and committees",
  "1.5": "Financial management",
  "1.6": "Community engagement",
  "1.7": "Safety and security leadership",
  "1.8": "Professional development",
  "1.9": "Monitoring and evaluation",
  "1.10": "Innovation in leadership",
  "1.11": "Inclusive leadership",
  "1.12": "Stakeholder communication",
  "2.1": "Curriculum implementation",
  "2.2": "Pedagogical practices",
  "2.3": "Classroom processes",
  "2.4": "Learning materials",
  "2.5": "ICT in teaching",
  "2.6": "Formative assessment",
  "2.7": "Learning support and remediation",
  "2.8": "Student participation",
  "2.9": "Remedial teaching",
  "2.10": "Assessment practices and feedback",
  "2.11": "Teacher collaboration",
  "2.12": "Student-centred learning",
  "3.1": "Learning outcomes",
  "3.2": "Student progress tracking",
  "3.3": "Co-curricular activities",
  "3.4": "Holistic development",
  "3.5": "Life skills",
  "4.1": "Physical infrastructure",
  "4.2": "Classroom environment",
  "4.3": "Sanitation and hygiene",
  "4.4": "Drinking water",
  "4.5": "Electricity and lighting",
  "4.6": "Safety measures",
  "4.7": "Library and learning resources",
  "4.8": "Playground and sports",
  "4.9": "Accessibility",
  "4.10": "Disaster preparedness",
  "4.11": "Maintenance",
  "5.1": "Inclusive education",
  "5.2": "Gender equity",
  "5.3": "Community participation",
  "5.4": "Parent engagement",
  "5.5": "Social inclusion",
  "5.6": "CWSN support",
  "5.7": "RTE compliance",
  "5.8": "Cultural inclusion",
  "5.9": "Community contribution",
  "5.10": "Partnerships",
  "5.11": "Parent-teacher collaboration",
  "5.12": "Community outreach",
  "6.1": "School accreditation readiness",
  "6.2": "Data management",
  "6.3": "Continuous improvement",
  "6.4": "Innovation in school",
  "6.5": "Quality monitoring",
  "6.6": "Digital governance",
  "6.7": "Best practices sharing",
};

const MANAGEMENT_LABELS = {
  zillaParishadZp: "Zilla Parishad (ZP)",
  privateAided: "Private Aided",
  privateUnaided: "Private Unaided",
  municipal: "Municipal",
  katakMandal: "Katak Mandal",
  socialWelfarePrivateUnaided: "Social Welfare (Private Unaided)",
  apangKalyanPrivateUnAided: "Apang Kalyan (Private Unaided)",
  unrecognized: "Unrecognized",
};

const CATEGORY_LABELS = {
  primary: "Primary",
  primaryUpperPrimary: "Primary + Upper Primary",
  primaryUpperPrimaryHigherScript: "Primary + Upper Primary + Higher",
  upperPrimary: "Upper Primary",
  secondary: "Secondary",
  higherSecondary: "Higher Secondary",
};

export function getChapterLabel(chapter) {
  return CHAPTERS[Number(chapter)] || `Chapter ${chapter}`;
}

export function getSectionLabelShort(code) {
  if (!code) return "";
  return SECTIONS[String(code).trim()] || String(code);
}

export function getSectionLabel(code) {
  if (!code) return "";
  const short = getSectionLabelShort(code);
  return `${code} — ${short}`;
}

export function getManagementLabel(key) {
  if (!key) return "Unknown";
  return MANAGEMENT_LABELS[key] || String(key).replace(/_/g, " ");
}

export function getCategoryLabel(key) {
  if (!key) return "Unknown";
  return CATEGORY_LABELS[key] || String(key).replace(/_/g, " ");
}

export function fmt2(v) {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return "—";
  return n.toFixed(2);
}
